import { Navigate } from 'react-router-dom';

import { authorized, authorizedLoader, isRegularUser } from '../../../utils/loaders.ts';
import {
    accountTabLoader,
    contactTabLoader,
    educationEditLoader,
    educationTabLoader,
    experienceEditLoader,
    experienceTabLoader,
    generalTabLoader,
    notificationsTabLoader,
} from './loaders.ts';
import {
    ADMIN_USER_PATH,
    ADMIN_USER_SETTINGS_ACCOUNT_PATH,
    ADMIN_USER_SETTINGS_CONTACT_PATH,
    ADMIN_USER_SETTINGS_EDUCATION_ADD_PATH,
    ADMIN_USER_SETTINGS_EDUCATION_EDIT_PATH,
    ADMIN_USER_SETTINGS_EDUCATION_PATH,
    ADMIN_USER_SETTINGS_EXPERIENCE_ADD_PATH,
    ADMIN_USER_SETTINGS_EXPERIENCE_EDIT_PATH,
    ADMIN_USER_SETTINGS_EXPERIENCE_PATH,
    ADMIN_USER_SETTINGS_NOTIFICATIONS_PATH,
    ADMIN_USER_SETTINGS_PASSWORD_PATH,
    ADMIN_USER_SETTINGS_PATH,
    ADMIN_USER_SETTINGS_PROFILE_PATH,
} from './paths.ts';

export default [
    {
        path: ADMIN_USER_PATH,
        element: <Navigate to={ADMIN_USER_SETTINGS_PATH} replace={true} />,
    },
    {
        handle: {
            title: ['admin:userSettingsPage.documentTitle'],
        },
        path: ADMIN_USER_SETTINGS_PATH,
        lazy: async () => ({ Component: (await import('./pages/UserSettingsPage.tsx')).default }),
        children: [
            {
                index: true,
                element: <Navigate to={ADMIN_USER_SETTINGS_PROFILE_PATH} replace={true} />,
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.generalTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_PROFILE_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ProfileTab.tsx')).default }),
                loader: authorizedLoader(generalTabLoader, isRegularUser),
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.contactTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_CONTACT_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ContactTab.tsx')).default }),
                loader: authorizedLoader(contactTabLoader, isRegularUser),
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.experienceTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_EXPERIENCE_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ExperienceTab.tsx')).default }),
                loader: authorizedLoader(experienceTabLoader, isRegularUser),
                children: [
                    {
                        handle: {
                            title: ['admin:userSettingsPage.addExperienceDocumentTitle'],
                        },
                        path: ADMIN_USER_SETTINGS_EXPERIENCE_ADD_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/ExperienceTab.tsx')).AddExperienceFormDialog,
                        }),
                    },
                    {
                        handle: {
                            title: ['admin:userSettingsPage.editExperienceDocumentTitle'],
                        },
                        path: ADMIN_USER_SETTINGS_EXPERIENCE_EDIT_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/ExperienceTab.tsx')).EditExperienceFormDialog,
                        }),
                        loader: authorizedLoader(experienceEditLoader, isRegularUser),
                    },
                ],
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.educationTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_EDUCATION_PATH,
                lazy: async () => ({ Component: (await import('./tabs/EducationTab.tsx')).default }),
                loader: authorizedLoader(educationTabLoader, isRegularUser),
                children: [
                    {
                        handle: {
                            title: ['admin:userSettingsPage.addEducationDocumentTitle'],
                        },
                        path: ADMIN_USER_SETTINGS_EDUCATION_ADD_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/EducationTab.tsx')).AddEducationFormDialog,
                        }),
                    },
                    {
                        handle: {
                            title: ['admin:userSettingsPage.editEducationDocumentTitle'],
                        },
                        path: ADMIN_USER_SETTINGS_EDUCATION_EDIT_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/EducationTab.tsx')).EditEducationFormDialog,
                        }),
                        loader: authorizedLoader(educationEditLoader, isRegularUser),
                    },
                ],
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.accountTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_ACCOUNT_PATH,
                lazy: async () => ({ Component: (await import('./tabs/AccountTab.tsx')).default }),
                loader: authorizedLoader(accountTabLoader),
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.notificationsTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_NOTIFICATIONS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/NotificationsTab.tsx')).default }),
                loader: authorizedLoader(notificationsTabLoader),
            },
            {
                handle: {
                    title: ['admin:userSettingsPage.passwordTabDocumentTitle'],
                },
                path: ADMIN_USER_SETTINGS_PASSWORD_PATH,
                lazy: async () => ({ Component: (await import('./tabs/PasswordTab.tsx')).default }),
                loader: authorized(),
            },
        ],
    },
];
